/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-06 11:25:23
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2024-12-06 11:36:44
 */
import { logoutApi } from '@ssv-website/hooks';
import { logoutToHomePage } from './config';

// 退出登录
export const handleLogout = async () => {
  await logoutApi();
  let isToHome = false;
  // 特定情况回到首页，需去config文件配置路径  支持模糊路径
  const { pathname } = window.location;
  logoutToHomePage.forEach((url) => {
    if (pathname.includes(url)) {
      isToHome = true;
    }
  });
  if (isToHome) {
    window.location.href = '/';
    return;
  }
  window.location.reload();
};
